import { T } from '../domaine/libelles'
import { el, requis, vider } from './dom'
import { aller, ongletCourant, ONGLETS, type Onglet } from './routeur'

const LIBELLES: Record<Onglet, string> = {
  patrouille: T.ongletPatrouille,
  signaler: T.ongletSignaler,
  lampe: T.ongletLampe,
  saison: T.ongletSaison,
  animer: T.ongletAnimer,
}

export function rendreOnglets(): void {
  const noeud = requis('onglets')
  const actif = ongletCourant()

  vider(noeud)

  for (const onglet of ONGLETS) {
    const estActif = onglet === actif
    const bouton = el('button', {
      type: 'button',
      class: estActif ? 'onglet onglet--actif' : 'onglet',
      'aria-current': estActif ? 'page' : undefined,
    })
    bouton.append(el('span', { class: 'onglet__libelle', text: LIBELLES[onglet].toUpperCase() }))
    bouton.addEventListener('click', () => aller(onglet))
    noeud.append(bouton)
  }
}
